import React, {ReactElement} from 'react';
import {EventKind} from 'services/analytics';
import {compose} from 'shared/utils/compose';
import {toReadable} from 'shared/utils/number';
import {useAnalytics} from 'ui/adapters/Analytics';
import {SpendSaved, SpendSavedProps} from 'ui/adapters/Core';
import {Button, SectionConstraints} from 'components/Button';
import {Option} from './style';

export const SpendOption = (): ReactElement => {
  const registerTransfer = useAnalytics(EventKind.TransferSavedToNextDay);

  return (
    <SpendSaved>
      {({oldAmount, newAmount, onSelectOption}: SpendSavedProps) => (
        <Option data-test='option'>
          <SectionConstraints>
            <Button color='yellow' onPress={compose(onSelectOption, registerTransfer)}>
              Потратить всё сегодня
            </Button>
          </SectionConstraints>
          <span data-test='new'>{toReadable(newAmount)}</span> вместо{' '}
          <span data-test='old'>{toReadable(oldAmount)}</span> на сегодня
        </Option>
      )}
    </SpendSaved>
  );
};
